<template>
    <div class="heroesLeaderboard">
        <div class="detail-box_operate">
            <div class="operate-filter">
                <div class="operate-filter_label">选择习题:</div>
                <el-select v-model="paper_id" placeholder="请选择" style="width: 300px" class="paper-select"
                    @change="handlePaperChange">
                    <el-option v-for="item in paperList" :key="item.paper_id" :label="item.paper_name"
                        :value="item.paper_id"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="$router.back()">返回</el-button>
        </div>
        <div class="course-ware-content" :native="false">
            <PaperDetail  :paper_id="paper_id"></PaperDetail>
        </div>
    </div>
</template>
<script>
import PaperDetail from "./PaperDetail.vue";
export default {
    data() {
        return {
            paper_id: undefined,
            paperList: [],
            typeId: '',
            zhangIndex: '',
            jieIndex: '',
            file_path: '',
            resource_id: '',
        };
    },
    components: {
        PaperDetail
    },
    methods: {
        getPaperList() {
            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(localStorage.getItem("teacherChapter")),
                course_node: Number(localStorage.getItem("teacherNode")),
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_knowledge_paper_list, params, (res) => {
                if (res.code === 200) {
                    this.paperList = res.data.list || [];

                    if (this.paperList.length > 0) {
                        this.paper_id = this.paperList[0].paper_id;
                    } else {

                        this.paper_id = undefined;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        init() {
            this.typeId = 6;
            this.zhangIndex = Number(localStorage.getItem("teacherChapter"));
            this.jieIndex = Number(localStorage.getItem("teacherNode"));
            this.file_path = this.$route.query.file_path ? this.$route.query.file_path : "";
            this.resource_id =654;
        },
        handlePaperChange(){

        }
    },
    mounted() {
        this.getPaperList()
        this.init()
    },
};
</script>
<style lang="scss" scoped>
.heroesLeaderboard {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;

    .detail-box_operate {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin-top: 20px;
        margin-bottom: 20px;

        .operate-filter {
            display: flex;
            align-items: center;
            gap: 20px;

            &_label {
                height: 30px;
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 30px;
                flex-shrink: 0;
            }

            ::v-deep .el-input__inner {
                background-color: transparent !important;
                height: 40px !important;
            }
        }

        .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 36px;
        }
    }

}

::v-deep .el-breadcrumb {
    padding-bottom: 20px;
}

.course-ware-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
</style>